module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-9358ae97f2707d4f1fcab6ec4eecb991.png";